import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../../services/ImageService";
import '../../../../../../styles/Common.scss';
import '../../../WorldPages.scss';
import '../MagicItemsPage.scss';

interface MagicBulletguardPageProps {
}

const MagicBulletguardPage = (props: MagicBulletguardPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Bulletguards - Chase the Fox`,
        description: "Bulletguards are wearable magic items that protect their wielders from projectile attacks in Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "bullet guard", "bulletguard", "magic bullet guard"],
        imgSrc: `chase/world/magic/items/bulletguard.png`,
        url: `world/magic/items/bulletguard`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Bulletguards">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc('chase/world/magic/items/bulletguard.png')}
                         alt="An officer's badge with a magic aura"
                         title="Badges like this one have historically been used as bulletguards"/>
                    <p>
                        Bulletguards are items that can be worn by anyone, protecting them from projectile attacks. They
                        work using a <NavLink className="world-link" to="/world/magic/elements/space">space</NavLink> magic
                        enchantment that detects an object's position in the space around the wearer and creates a
                        shield around the point of contact to soften the impact. The same amount of magic is expended
                        regardless of the size of the object. Therefore, the larger the projectile is, the less
                        effective the protection from the attack. For example, it provides more protection against
                        arrows than it does a thrown stone.
                    </p>
                    <p>
                        If the target of the attack is not detected to be airborne, however, then the bulletguard fails
                        to activate. In such a case, certain enchantments like those provided by the space
                        or <NavLink className="world-link" to="/world/magic/elements/earth">earth</NavLink> elements
                        can evade the protection of a bulletguard. Enchanted bullets and shot are very uncommon though;
                        where an arrow or throwing knife can be retrieved and potentially reused, a bullet cannot. It
                        is also more difficult to enchant such a spell onto a smaller object like that. An anthro which
                        goes airborne (which is not uncommon as several different species have the ability to fly) for
                        an attack can also be defended against by a bulletguard, which improves their utility. Again, an
                        enchantment on the user or their weapon can get around or overwhelm the protection of a
                        bulletguard.
                    </p>
                    <p>
                        The technology was developed as an answer to the rise of firearms in Casarok. This tie to guns
                        is what gave bulletguards their name. As firearms became more developed and their ease of use
                        increased over time, the development of bulletguards became more and more imperative. The first
                        known bulletguards were used in
                        early <NavLink className="world-link" to="/world/history">post-Cataclysmic</NavLink> Casarok
                        when hand cannons and early firearms were starting to be adopted by more militaries. In that
                        time, they tended to be enchanted onto shields. As the bulletguard spell improved, it was
                        enchanted onto smaller and smaller objects. For example, a badge, armlet, or headband could
                        become a bulletguard.
                    </p>
                    <p>
                        In the <NavLink className="world-link" to="/world/history/modern-age">modern day</NavLink>,
                        the magic of bulletguards are put
                        onto <NavLink className="world-link" to="/world/magic/items/mage-tech">mage-tech</NavLink> circuits
                        that are installed in most smartphones. The adoption rate of bulletguards is therefore extremely
                        high throughout the world. This commonality has made the use of various types of weapons for
                        protection more popular in places where smartphones are used. It's not unthought of to see
                        swords, spears, crossbows, and other such archaic weapons used and smithed throughout the world,
                        especially if they are enchanted themselves. Collectors pay top dollar for antiques and
                        well-crafted modern weapons.
                    </p>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicBulletguardPage;